import CopyButton from "@components/CopyButton/CopyButton"
import TransactionDetailStatusIcon, { Status } from "@components/TransactionDetailStatusIcon/TransactionDetailStatusIcon"
import PaymentLinkTransactionStatusIcon, { PaymentLinkStatus } from "@components/PaymentLinkTransactionStatusIcon/PaymentLinkTransactionStatusIcon"
import {
    BaseValue,
    BoldValue,
    StatusContainer,
    StatusRow,
    StatusText,
    Divider,
    TitleText,
    RowContainer,
    CopyButtonContainer,
    PaymentLinkStatusText,
    Container,
    ActionsContainer,
    QRButtonContainer
} from "./TransactionInformationRow.styles"
import QRButton from "@components/QRButton/QRButton"
import { useState } from "react"
import QRBottomSheet from "@components/QRBottomSheet/QRBottomSheet"
import { capitalizeText } from "@lib/utils"
import { getLocalizedStatus } from "@constants/transaction"

type Props = {
    type: 'normal' | 'bold' | 'status' | 'payment-link-status'
    title: string
    value: string
    onCopy?: () => void
    qrHeaderTitle?: string
    qrLabel?: string
}

const Value = ({ type, value }: { type: 'normal' | 'bold' | 'status' | 'payment-link-status'; value: string | number }) => {
    switch (type) {
        case 'normal':
            return (
                <BaseValue>
                    {value}
                </BaseValue>
            )
        case 'bold':
            return (
                <BoldValue>
                    {value}
                </BoldValue>
            )
        case 'status':
            return (
                <StatusContainer>
                    <StatusRow>
                        <StatusText $status={value.toString().toLocaleUpperCase() as Status}>
                            {getLocalizedStatus(value.toString())}
                        </StatusText>
                        <TransactionDetailStatusIcon status={value.toString().toLocaleUpperCase() as Status} />
                    </StatusRow>
                    <Divider />
                </StatusContainer>
            )
        case 'payment-link-status':
            return (
                <StatusContainer>
                    <StatusRow>
                        <PaymentLinkStatusText $status={value.toString().toLocaleUpperCase() as PaymentLinkStatus}>
                            {getLocalizedStatus(value.toString())}
                        </PaymentLinkStatusText>
                        <PaymentLinkTransactionStatusIcon status={value.toString().toLocaleUpperCase() as PaymentLinkStatus} strokeWidth={1.5} />
                    </StatusRow>
                    <Divider />
                </StatusContainer>
            )
    }
}

const TransactionInformationRow = ({ type, title, value, onCopy, qrHeaderTitle, qrLabel }: Props) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <Container>
            <TitleText>
                {title}
            </TitleText>
            <RowContainer>
                <Value
                    type={type}
                    value={value}
                />
                <ActionsContainer>
                    {qrHeaderTitle && qrLabel && (
                        <QRButtonContainer>
                            <QRButton
                                onClick={() => setIsOpen(true)}
                            />
                            <QRBottomSheet
                                isOpen={isOpen}
                                onClose={() => setIsOpen(false)}
                                qrValue={value}
                                height="320px"
                                bottomSheetHeaderTitle={qrHeaderTitle}
                                qrLabel={qrLabel}
                            />
                        </QRButtonContainer>
                    )}
                    {onCopy &&
                        <CopyButtonContainer>
                            <CopyButton onClick={onCopy} stringToCopy={value} size={36} />
                        </CopyButtonContainer>
                    }
                </ActionsContainer>
            </RowContainer>
        </Container>
    )
}

export default TransactionInformationRow